// hard cap on a serialized UserSettings value, enforced by the backend on write. lives here so a
// client that builds a large value (e.g. the remembered import-category dictionary) can trim itself
// to the same budget instead of discovering the limit as a 400.
export const MAX_SETTING_VALUE_LENGTH = 10_000
